

export class LinguaSistema {
    nome: string;
    descrizione: string;
    rtl: boolean;
}

export class MultiLangString {

    it: string; // Italiano
    en: string; // Inglese
    fr: string; // Francese
    es: string; // Spagnolo
    sq: string; // Albanese
    ar: string; // Arabo
    zh: string; // Cinese
    ro: string; // Rumeno

    public getValue(lang: string = 'it') {
        return this[lang] || this.it;
    }


    public toLocaleString(locale = 'it') {
        return this.getValue(locale);
    }

    public toString = (): string => {
        return this.getValue();
    }

}
